const initialState = {
    title: "",
    copies:1,
  };
  
  export function UniqueTabReducer(state = initialState, { type, payload }) {
    switch (type) {
      case "UNIQUE_TAB_SELECT": {
        const { key, data } = payload;
        return {
          ...state,
          [key]: data,
        };
      }
      default:
        return state;
    }
  }
  